import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Badge } from '../../components/ui/Badge';
import { Patient } from '../../types';
import { Search, UserPlus, Clock, ArrowRight } from 'lucide-react';
export const ReceptionDashboard: React.FC = () => {
  const {
    patients,
    addPatient,
    createEncounter,
    getPatientEncounters
  } = useData();
  const [activeTab, setActiveTab] = useState<'register' | 'search'>('search');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null);
  // Form state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    sex: 'Male' as 'Male' | 'Female',
    age: '',
    maritalStatus: 'Single' as 'Married' | 'Single',
    address: '',
    contact: '',
    occupation: '',
    nextOfKin: '',
    nokContact: '',
    nokRelationship: '',
    allergies: '',
    hivStatus: 'Unknown' as 'Positive' | 'Negative' | 'Unknown'
  });
  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    const newPatient = addPatient({
      ...formData,
      age: parseInt(formData.age) || 0
    });
    // Auto create encounter and send to nursing
    createEncounter(newPatient.id);
    // Reset form and show success
    setFormData({
      firstName: '',
      lastName: '',
      sex: 'Male',
      age: '',
      maritalStatus: 'Single',
      address: '',
      contact: '',
      occupation: '',
      nextOfKin: '',
      nokContact: '',
      nokRelationship: '',
      allergies: '',
      hivStatus: 'Unknown'
    });
    alert(`Patient registered successfully! BMC Number: ${newPatient.bmcFileNumber}. Sent to Nursing.`);
    setActiveTab('search');
    setSearchQuery(newPatient.bmcFileNumber);
  };
  const handleSendToNursing = (patientId: string) => {
    createEncounter(patientId);
    alert('Patient file sent to Nursing successfully.');
    setSelectedPatient(null);
  };
  const filteredPatients = patients.filter(p => p.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || p.lastName.toLowerCase().includes(searchQuery.toLowerCase()) || p.bmcFileNumber.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-1328">
      <div className="flex justify-between items-center" data-id="element-1329">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1330">
          Reception Dashboard
        </h1>
        <div className="flex space-x-2" data-id="element-1331">
          <Button variant={activeTab === 'search' ? 'primary' : 'outline'} onClick={() => setActiveTab('search')} data-id="element-1332">
            <Search className="w-4 h-4 mr-2" data-id="element-1333" /> Search Patient
          </Button>
          <Button variant={activeTab === 'register' ? 'primary' : 'outline'} onClick={() => setActiveTab('register')} data-id="element-1334">
            <UserPlus className="w-4 h-4 mr-2" data-id="element-1335" /> Register New
          </Button>
        </div>
      </div>

      {activeTab === 'register' && <Card title="Register New Patient" data-id="element-1336">
          <form onSubmit={handleRegister} className="space-y-6" data-id="element-1337">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1338">
              <Input label="First Name" required value={formData.firstName} onChange={e => setFormData({
            ...formData,
            firstName: e.target.value
          })} data-id="element-1339" />
              <Input label="Last Name" required value={formData.lastName} onChange={e => setFormData({
            ...formData,
            lastName: e.target.value
          })} data-id="element-1340" />
              <Input label="Age" type="number" required value={formData.age} onChange={e => setFormData({
            ...formData,
            age: e.target.value
          })} data-id="element-1341" />

              <Select label="Sex" options={[{
            value: 'Male',
            label: 'Male'
          }, {
            value: 'Female',
            label: 'Female'
          }]} required value={formData.sex} onChange={e => setFormData({
            ...formData,
            sex: e.target.value as any
          })} data-id="element-1342" />
              <Select label="Marital Status" options={[{
            value: 'Single',
            label: 'Single'
          }, {
            value: 'Married',
            label: 'Married'
          }]} required value={formData.maritalStatus} onChange={e => setFormData({
            ...formData,
            maritalStatus: e.target.value as any
          })} data-id="element-1343" />
              <Input label="Contact Number" required value={formData.contact} onChange={e => setFormData({
            ...formData,
            contact: e.target.value
          })} data-id="element-1344" />

              <Input label="Home Address" className="md:col-span-2" required value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} data-id="element-1345" />
              <Input label="Occupation" value={formData.occupation} onChange={e => setFormData({
            ...formData,
            occupation: e.target.value
          })} data-id="element-1346" />
            </div>

            <div className="border-t border-gray-200 pt-4" data-id="element-1347">
              <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1348">
                Emergency Contact
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1349">
                <Input label="Next of Kin Name" required value={formData.nextOfKin} onChange={e => setFormData({
              ...formData,
              nextOfKin: e.target.value
            })} data-id="element-1350" />
                <Input label="Relationship" required value={formData.nokRelationship} onChange={e => setFormData({
              ...formData,
              nokRelationship: e.target.value
            })} data-id="element-1351" />
                <Input label="Contact Number" required value={formData.nokContact} onChange={e => setFormData({
              ...formData,
              nokContact: e.target.value
            })} data-id="element-1352" />
              </div>
            </div>

            <div className="flex justify-end pt-4" data-id="element-1353">
              <Button type="submit" size="lg" data-id="element-1354">
                Register & Send to Nursing
              </Button>
            </div>
          </form>
        </Card>}

      {activeTab === 'search' && <div className="space-y-6" data-id="element-1355">
          <Card data-id="element-1356">
            <div className="relative" data-id="element-1357">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1358">
                <Search className="h-5 w-5 text-gray-400" data-id="element-1359" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search by name or BMC number..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1360" />
            </div>
          </Card>

          {searchQuery && !selectedPatient && <Card noPadding data-id="element-1361">
              <ul className="divide-y divide-gray-200" data-id="element-1362">
                {filteredPatients.length > 0 ? filteredPatients.map(patient => <li key={patient.id} className="p-4 hover:bg-gray-50 cursor-pointer flex justify-between items-center" onClick={() => setSelectedPatient(patient)} data-id="element-1363">
                      <div data-id="element-1364">
                        <p className="text-sm font-medium text-blue-600" data-id="element-1365">
                          {patient.bmcFileNumber}
                        </p>
                        <p className="text-lg font-bold text-gray-900" data-id="element-1366">
                          {patient.firstName} {patient.lastName}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-1367">
                          {patient.age} yrs • {patient.sex} • {patient.contact}
                        </p>
                      </div>
                      <ArrowRight className="h-5 w-5 text-gray-400" data-id="element-1368" />
                    </li>) : <li className="p-8 text-center text-gray-500" data-id="element-1369">
                    No patients found matching "{searchQuery}"
                  </li>}
              </ul>
            </Card>}

          {selectedPatient && <div className="space-y-6" data-id="element-1370">
              <Button variant="ghost" onClick={() => setSelectedPatient(null)} className="mb-2" data-id="element-1371">
                ← Back to search results
              </Button>

              <Card title="Patient Details" action={<Button onClick={() => handleSendToNursing(selectedPatient.id)} data-id="element-1373">
                    Send to Nursing
                  </Button>} data-id="element-1372">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-1374">
                  <div data-id="element-1375">
                    <p className="text-sm text-gray-500" data-id="element-1376">BMC Number</p>
                    <p className="font-medium" data-id="element-1377">
                      {selectedPatient.bmcFileNumber}
                    </p>
                  </div>
                  <div data-id="element-1378">
                    <p className="text-sm text-gray-500" data-id="element-1379">Full Name</p>
                    <p className="font-medium" data-id="element-1380">
                      {selectedPatient.firstName} {selectedPatient.lastName}
                    </p>
                  </div>
                  <div data-id="element-1381">
                    <p className="text-sm text-gray-500" data-id="element-1382">Age / Sex</p>
                    <p className="font-medium" data-id="element-1383">
                      {selectedPatient.age} / {selectedPatient.sex}
                    </p>
                  </div>
                  <div data-id="element-1384">
                    <p className="text-sm text-gray-500" data-id="element-1385">Contact</p>
                    <p className="font-medium" data-id="element-1386">{selectedPatient.contact}</p>
                  </div>
                  <div data-id="element-1387">
                    <p className="text-sm text-gray-500" data-id="element-1388">Address</p>
                    <p className="font-medium" data-id="element-1389">{selectedPatient.address}</p>
                  </div>
                  <div data-id="element-1390">
                    <p className="text-sm text-gray-500" data-id="element-1391">Next of Kin</p>
                    <p className="font-medium" data-id="element-1392">
                      {selectedPatient.nextOfKin} ({selectedPatient.nokContact})
                    </p>
                  </div>
                  <div data-id="element-1393">
                    <p className="text-sm text-gray-500" data-id="element-1394">Allergies</p>
                    <p className="font-medium text-red-600" data-id="element-1395">
                      {selectedPatient.allergies}
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6" data-id="element-1396">
                  <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center" data-id="element-1397">
                    <Clock className="w-5 h-5 mr-2 text-gray-500" data-id="element-1398" /> Visit
                    History
                  </h4>

                  {getPatientEncounters(selectedPatient.id).length > 0 ? <div className="space-y-3" data-id="element-1399">
                      {getPatientEncounters(selectedPatient.id).map(enc => <div key={enc.id} className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex justify-between items-center" data-id="element-1400">
                          <div data-id="element-1401">
                            <p className="font-medium text-gray-900" data-id="element-1402">
                              {new Date(enc.startedAt).toLocaleDateString()} at{' '}
                              {new Date(enc.startedAt).toLocaleTimeString()}
                            </p>
                            <p className="text-sm text-gray-500" data-id="element-1403">
                              {enc.lastAttendingClinician ? `Seen by ${enc.lastAttendingClinician}` : 'No clinician assigned'}
                            </p>
                          </div>
                          <Badge variant={enc.stage === 'COMPLETED' ? 'success' : 'warning'} data-id="element-1404">
                            {enc.stage}
                          </Badge>
                        </div>)}
                    </div> : <p className="text-gray-500 italic" data-id="element-1405">
                      No previous visits found.
                    </p>}
                </div>
              </Card>
            </div>}
        </div>}
    </div>;
};